document.addEventListener('alpine:init', () => {
  Alpine.data('ProductCardSlider', () => ({
    init() {
      const revealFallbackImage = () => {
        this.$root.parentElement
          .querySelector('.product-card-first-image')
          ?.classList.remove('opacity-0');
      };

      // Always guarantee the plain fallback image becomes visible, even if Splide
      // never loads or throws below - otherwise the card is left permanently
      // hidden behind its opacity-0 wrapper, rendering as a solid black tile.
      if (typeof Splide === 'undefined') {
        console.error('Splide not loaded!');
        revealFallbackImage();
        return;
      }

      let splide;
      try {
        splide = new Splide(this.$root, {
          type: 'loop', // "slide, loop"
          perPage: 1,
          arrows: true,
          pagination: true,
          autoplay: false,
          lazyLoad: 'nearby', // just load next 1 image
        }).mount();
      } catch (err) {
        console.error('Splide failed to initialize:', err);
        revealFallbackImage();
        return;
      }

      this.$root.classList.remove('opacity-0');
      revealFallbackImage();
      this.$root.closest('.product-card').setAttribute('data-slider-loaded', '');

      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        this.$root.addEventListener('mouseenter', () => {
          splide.options = { speed: 1 };
          splide.go(1);
          splide.options = { speed: 400 };
        });
      }
    }
  }));
});
